/**
 * PDP — Gudslip (iurop-pdp.liquid + iurop-reviews.liquid).
 * - Galeria: thumbnails -> imagen principal.
 * - Selector de variante (packs / select sticky): precio, compare, %OFF, imagen,
 *   URL (?variant=) y precios de suscripcion (selling plans reales).
 * - Compra unica vs suscripcion: activa/desactiva el input selling_plan.
 * - Stepper de cantidad (buy box y sticky, sincronizados).
 * - Add to cart AJAX (fetch /cart/add.js) -> CustomEvent('cart:updated') que abre
 *   el sidecart existente (contrato de iurop-cart-drawer.js).
 * - Barra sticky: IntersectionObserver sobre el buy box.
 * - Carrusel UGC: dots por scroll-snap + play/pausa de video inline.
 * - "Leer mas" de la descripcion y "Ver mas resenas" (iurop-reviews).
 * Todo por atributos data-*; guard de reentrada como iurop-product-card.js.
 */
(function () {
  'use strict';

  if (window.__iuropPdpReady) return;
  window.__iuropPdpReady = true;

  var CART_ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';

  /* ────────────────────────────── helpers ────────────────────────────── */

  function parseVariants(section) {
    var el = section.querySelector('[data-pdp-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function findVariant(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return list[i];
    }
    return null;
  }

  function setText(el, value) {
    if (el) el.textContent = value;
  }

  /* ────────────────────────────── PDP init ───────────────────────────── */

  function initPdp(section) {
    if (section.__pdpInit) return;
    section.__pdpInit = true;

    var variants = parseVariants(section);
    var form = section.querySelector('[data-pdp-form]');
    var slidesTrack = section.querySelector('[data-pdp-slides]');
    var offBadge = section.querySelector('[data-pdp-off]');
    var priceEl = section.querySelector('[data-pdp-price]');
    var compareEl = section.querySelector('[data-pdp-compare]');
    var subPriceEl = section.querySelector('[data-pdp-sub-price]');
    var subCompareEl = section.querySelector('[data-pdp-sub-compare]');
    var sellingPlanInput = section.querySelector('[data-pdp-selling-plan]');
    var stickyBar = section.querySelector('[data-pdp-sticky]');
    var stickySelect = section.querySelector('[data-pdp-sticky-select]');
    var stickyQty = section.querySelector('[data-pdp-sticky-qty]');
    var stickyPrice = section.querySelector('[data-pdp-sticky-price]');
    var qtyInput = form ? form.querySelector('[data-pdp-qty-input]') : null;
    var stockEl = section.querySelector('[data-pdp-stock]');
    var stockMsg = stockEl ? stockEl.querySelector('[data-pdp-stock-msg]') : null;

    /* ── cantidad con descuento por tramos (1 / 2 -10% / 3 -20%) ── */
    var tiersEl = section.querySelector('[data-pdp-tiers]');
    var moneyFmt = tiersEl ? (tiersEl.getAttribute('data-money-format') || '€{{amount}}') : '€{{amount}}';
    var tierQty = 1;
    var tierPct = 0;

    function tierFormatMoney(cents) {
      cents = Math.round(Number(cents) || 0);
      var m = moneyFmt.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      function d(n, p, th, dc) {
        var f = (n / 100).toFixed(p).split('.');
        var u = f[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
        return u + (f[1] ? dc + f[1] : '');
      }
      var v;
      if (key === 'amount_no_decimals') v = d(cents, 0, ',', '.');
      else if (key === 'amount_with_comma_separator') v = d(cents, 2, '.', ',');
      else if (key === 'amount_no_decimals_with_comma_separator') v = d(cents, 0, '.', ',');
      else v = d(cents, 2, ',', '.');
      var out = moneyFmt.replace(/\{\{\s*\w+\s*\}\}/, v);
      if (out.indexOf('€') !== -1) out = out.replace(/€/g, '').trim() + ' €';
      return out;
    }

    // Recalcula el precio mostrado como TOTAL del tramo (precio unidad x cantidad x
    // (1 - %/100)). Tachado = total sin descuento (o compare_at x cantidad si hay oferta).
    function updateTierPrice() {
      if (!tiersEl) return;
      var v = findVariant(variants, currentVariantId());
      if (!v || typeof v.price !== 'number') return;
      if (qtyInput) qtyInput.value = tierQty;
      if (stickyQty) stickyQty.value = tierQty;
      var base = v.price;
      var total = base * tierQty;
      var discounted = Math.round(total * (1 - tierPct / 100));
      var compareUnit = (v.compare && v.compare > base) ? v.compare : base;
      var compareTotal = compareUnit * tierQty;
      setText(priceEl, tierFormatMoney(discounted));
      if (compareEl) {
        var showCompare = compareTotal > discounted;
        compareEl.textContent = showCompare ? tierFormatMoney(compareTotal) : '';
        compareEl.classList.toggle('is-hidden', !showCompare);
      }
      setText(stickyPrice, tierFormatMoney(discounted));

      // Suscripción: precio = precio unidad del plan x cantidad. El descuento por
      // TRAMOS no acumula sobre la suscripción (la Function excluye las líneas con
      // selling_plan), así que aquí SOLO se multiplica por la cantidad seleccionada.
      if (subPriceEl && v.plans && v.plans.length) {
        var activePlanId = currentPlanId();
        var pl = null;
        for (var pi = 0; pi < v.plans.length; pi++) {
          if (String(v.plans[pi].id) === String(activePlanId)) { pl = v.plans[pi]; break; }
        }
        if (!pl) pl = v.plans[0];
        if (pl && typeof pl.price === 'number') {
          var subTotal = pl.price * tierQty;
          setText(subPriceEl, tierFormatMoney(subTotal));
          if (subCompareEl) {
            var showSubC = compareTotal > subTotal;
            subCompareEl.textContent = showSubC ? tierFormatMoney(compareTotal) : '';
            subCompareEl.classList.toggle('is-hidden', !showSubC);
          }
        }
      }

      // Mini texto de ahorro del tramo seleccionado ("Vas a ahorrar X por N uds").
      var savingsEl = section.querySelector('[data-pdp-tier-savings]');
      if (savingsEl) {
        var saved = total - discounted;
        if (tierPct > 0 && saved > 0) {
          var tpl = savingsEl.getAttribute('data-tpl') || '';
          savingsEl.innerHTML = tpl
            .replace('[amount]', '<strong>' + tierFormatMoney(saved) + '</strong>')
            .replace('[count]', String(tierQty));
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    }

    function setTier(qty, pct) {
      tierQty = qty; tierPct = pct;
      // Segmento activo
      section.querySelectorAll('[data-pdp-tier]').forEach(function (b) {
        var on = b.getAttribute('data-tier-qty') === String(qty);
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      // Píldora de ahorro del tramo seleccionado
      section.querySelectorAll('[data-tier-pill]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-tier-pill') === String(qty));
      });
      updateTierPrice();
    }

    function currentVariantId() {
      var checked = section.querySelector('[data-pdp-variant-input]:checked');
      if (checked) return checked.value;
      var hidden = section.querySelector('[data-pdp-variant-input]');
      return hidden ? hidden.value : null;
    }

    /* #15: productos con 2+ opciones → un selector por opción (unidades, tamaño).
       Casa los valores seleccionados con la variante del mapa y actualiza el id. */
    function selectByOptions() {
      var groups = section.querySelectorAll('[data-pdp-optgroup]');
      if (!groups.length) return;
      var sel = [];
      Array.prototype.forEach.call(groups, function (g) {
        var idx = parseInt(g.getAttribute('data-opt-index'), 10) - 1;
        var c = g.querySelector('[data-pdp-option]:checked');
        sel[idx] = c ? c.value : null;
        // Estado visual de las píldoras.
        Array.prototype.forEach.call(g.querySelectorAll('.gudslip-pdp__opt'), function (lbl) {
          lbl.classList.toggle('is-selected', !!c && lbl.contains(c));
        });
      });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] != null && variants[i].options[j] !== sel[j]) { ok = false; break; }
        }
        if (ok) { match = variants[i]; break; }
      }
      if (match) {
        var hid = section.querySelector('[data-pdp-variant-hidden]');
        if (hid) hid.value = match.id;
        refresh();
      }
    }

    function currentPlanId() {
      if (!sellingPlanInput) return '';
      return sellingPlanInput.getAttribute('data-default-plan') || '';
    }

    /* ── animación sutil al cambiar de pack ──
       Solo cuando cambia la VARIANTE (la cantidad de tiras), no al cambiar de
       frecuencia: ahí el importe de suscripción se actualiza sin llamar la
       atención. Se reinicia con un reflow para que funcione si el usuario
       salta rápido entre packs. */
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var lastVariantId = null;

    function swap(els) {
      if (reducedMotion) return;
      els.forEach(function (el) {
        if (!el) return;
        el.classList.remove('is-swap');
        void el.offsetWidth;
        el.classList.add('is-swap');
      });
    }

    /* ── precios / imagen según variante y plan ── */
    function refresh() {
      var v = findVariant(variants, currentVariantId());
      if (!v) return;

      var variantChanged = lastVariantId !== null && lastVariantId !== String(v.id);
      lastVariantId = String(v.id);

      setText(priceEl, v.price_f);
      if (compareEl) {
        compareEl.textContent = v.compare_f || '';
        compareEl.classList.toggle('is-hidden', !v.compare_f);
      }
      if (offBadge) {
        offBadge.textContent = v.off + '% OFF';
        offBadge.classList.toggle('is-hidden', !v.off);
      }

      var subPrice = v.price_f;
      if (v.plans && v.plans.length) {
        var planId = currentPlanId();
        var plan = null;
        for (var i = 0; i < v.plans.length; i++) {
          if (!planId || String(v.plans[i].id) === String(planId)) { plan = v.plans[i]; break; }
        }
        if (plan) subPrice = plan.price_f;
      }
      setText(subPriceEl, subPrice);
      if (subCompareEl) {
        subCompareEl.textContent = v.compare_f || '';
        subCompareEl.classList.toggle('is-hidden', !v.compare_f);
      }
      setText(stickyPrice, v.price_f);

      /* semáforo de stock: rojo + texto "agotado" si la variante no tiene stock */
      if (stockEl) {
        var soldOut = v.available === false;
        stockEl.classList.toggle('is-out', soldOut);
        if (stockMsg) {
          stockMsg.textContent = soldOut
            ? (stockEl.getAttribute('data-out') || '')
            : (stockEl.getAttribute('data-in') || '');
        }
      }

      if (variantChanged) {
        swap([priceEl, compareEl, offBadge, subPriceEl, subCompareEl, stickyPrice]);
      }

      if (v.image) showSlideBySrc(v.image);

      if (stickySelect && stickySelect.value !== String(v.id)) stickySelect.value = String(v.id);

      section.querySelectorAll('[data-pdp-pack]').forEach(function (pack) {
        var input = pack.querySelector('[data-pdp-variant-input]');
        pack.classList.toggle('is-selected', !!(input && input.checked));
      });

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* noop */ }

      // Con tramos activos, el precio mostrado es el TOTAL del tramo, no el unitario.
      if (tiersEl) updateTierPrice();
    }

    /* ── galería: una diapositiva por foto ──────────────────────────────────
       Escritorio: solo se pinta la `.is-active` (CSS). Móvil: el track es un
       carrusel con scroll-snap, así que además hay que DESPLAZARLO. En los dos
       casos la miniatura correspondiente queda marcada. */
    function slides() {
      return slidesTrack ? slidesTrack.querySelectorAll('[data-pdp-slide]') : [];
    }

    function markSlide(slide) {
      if (!slide) return;
      slides().forEach(function (s) { s.classList.toggle('is-active', s === slide); });
      var src = slide.getAttribute('data-full');
      section.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-full') === src);
      });
    }

    function showSlideBySrc(src) {
      if (!src || !slidesTrack) return;
      var target = null;
      slides().forEach(function (s) {
        if (!target && s.getAttribute('data-full') === src) target = s;
      });
      if (!target) return;
      markSlide(target);
      // Si el track scrollea (móvil), lo llevamos a la diapositiva elegida.
      if (slidesTrack.scrollWidth > slidesTrack.clientWidth + 1) {
        slidesTrack.scrollTo({ left: target.offsetLeft - slidesTrack.offsetLeft, behavior: 'smooth' });
      }
    }

    // Flechas de escritorio: ciclan por la diapositiva activa (con wrap-around).
    function stepSlide(dir) {
      var all = slides();
      if (all.length < 2) return;
      var idx = 0;
      all.forEach(function (s, i) { if (s.classList.contains('is-active')) idx = i; });
      var next = (idx + dir + all.length) % all.length;
      var target = all[next];
      markSlide(target);
      if (slidesTrack.scrollWidth > slidesTrack.clientWidth + 1) {
        slidesTrack.scrollTo({ left: target.offsetLeft - slidesTrack.offsetLeft, behavior: 'smooth' });
      }
    }

    /* ── Flecha que sigue al cursor (solo escritorio, ratón fino) ──
       El círculo con chevron sigue al puntero sobre la galería: mitad derecha →
       siguiente, mitad izquierda → anterior (con wrap-around en stepSlide). */
    (function setupCursorNav() {
      var media = section.querySelector('.gudslip-pdp__media');
      var cursor = section.querySelector('[data-pdp-cursor]');
      if (!media || !cursor || slides().length < 2) return;
      if (!window.matchMedia || !window.matchMedia('(pointer: fine)').matches) return;

      media.classList.add('has-cursor-nav');
      var dir = 1;

      function place(e) {
        var r = media.getBoundingClientRect();
        cursor.style.left = (e.clientX - r.left) + 'px';
        cursor.style.top = (e.clientY - r.top) + 'px';
        dir = (e.clientX - r.left) >= r.width / 2 ? 1 : -1;
        cursor.classList.toggle('is-next', dir === 1);
        cursor.classList.toggle('is-prev', dir === -1);
      }

      media.addEventListener('mouseenter', function (e) { place(e); cursor.classList.add('is-visible'); });
      media.addEventListener('mousemove', place);
      media.addEventListener('mouseleave', function () { cursor.classList.remove('is-visible'); });
      media.addEventListener('click', function (e) {
        if (e.target.closest('.gudslip-pdp__badges, [data-pdp-cursor]')) return;
        stepSlide(dir);
      });
    })();

    // En móvil el track arranca en scrollLeft 0: si la foto activa (la de la
    // variante) no es la primera, hay que colocarlo ahí sin animación.
    if (slidesTrack) {
      var initial = slidesTrack.querySelector('[data-pdp-slide].is-active');
      if (initial && slidesTrack.scrollWidth > slidesTrack.clientWidth + 1) {
        slidesTrack.scrollLeft = initial.offsetLeft - slidesTrack.offsetLeft;
      }
    }

    // Al deslizar con el dedo, la miniatura activa sigue a la foto visible.
    if (slidesTrack) {
      var slideScrollTimer;
      slidesTrack.addEventListener('scroll', function () {
        window.clearTimeout(slideScrollTimer);
        slideScrollTimer = window.setTimeout(function () {
          var all = slides();
          if (!all.length) return;
          var idx = Math.round(slidesTrack.scrollLeft / Math.max(1, all[0].offsetWidth));
          markSlide(all[Math.min(Math.max(idx, 0), all.length - 1)]);
        }, 80);
      }, { passive: true });
    }

    /* ── modo compra única / suscripción ── */
    function refreshMode() {
      var mode = 'single';
      var checked = section.querySelector('[data-pdp-mode]:checked');
      if (checked) mode = checked.value;
      var isSub = mode === 'subscription';

      var purchase = section.querySelector('[data-pdp-purchase]');
      if (purchase) purchase.classList.toggle('is-subscription', isSub);
      if (sellingPlanInput) {
        sellingPlanInput.disabled = !isSub;
        sellingPlanInput.value = isSub ? currentPlanId() : '';
      }
      syncModeLabels(isSub);
    }

    /* Copy dinámico del botón según el modo: compra única → "Añadir",
       suscripción → "Suscribirme". No tocamos el estado agotado (disabled). */
    function syncModeLabels(isSub) {
      var atc = section.querySelector('[data-pdp-atc]');
      if (atc && !atc.disabled) {
        var lbl = atc.querySelector('.gudslip-pdp__atc-label');
        // CTA siempre "Añadir al carrito" (petición cliente 2026-07-30), también en suscripción.
        if (lbl) lbl.textContent = atc.getAttribute('data-label-add');
      }
      var st = section.querySelector('[data-pdp-sticky-atc]');
      if (st && !st.disabled) {
        var full = st.querySelector('[data-sticky-lbl-full]');
        var short = st.querySelector('[data-sticky-lbl-short]');
        if (full) full.textContent = st.getAttribute('data-label-add');
        if (short) short.textContent = st.getAttribute('data-label-add-short');
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target.closest('[data-pdp-option]')) selectByOptions();
      if (e.target.closest('[data-pdp-variant-input]')) refresh();
      if (e.target.closest('[data-pdp-mode]')) refreshMode();
      if (stickySelect && e.target === stickySelect) {
        var input = section.querySelector('[data-pdp-variant-input][value="' + stickySelect.value + '"]');
        if (input) { input.checked = true; refresh(); }
      }
    });

    /* ── galería ── */
    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-pdp-thumb]');
      if (thumb) showSlideBySrc(thumb.getAttribute('data-full'));

      if (e.target.closest('[data-pdp-prev]')) stepSlide(-1);
      if (e.target.closest('[data-pdp-next]')) stepSlide(1);

      var tierBtn = e.target.closest('[data-pdp-tier]');
      if (tierBtn) {
        setTier(parseInt(tierBtn.getAttribute('data-tier-qty'), 10) || 1,
                parseInt(tierBtn.getAttribute('data-tier-pct'), 10) || 0);
      }

      /* stepper (buy box y sticky) */
      var minus = e.target.closest('[data-pdp-qty-minus]');
      var plus = e.target.closest('[data-pdp-qty-plus]');
      if (minus || plus) {
        var wrap = (minus || plus).closest('.gudslip-pdp__qty');
        var input = wrap ? wrap.querySelector('input') : null;
        if (input) {
          var val = parseInt(input.value, 10) || 1;
          val = plus ? val + 1 : Math.max(1, val - 1);
          input.value = val;
          /* sincroniza el otro stepper */
          if (qtyInput && input !== qtyInput) qtyInput.value = val;
          if (stickyQty && input !== stickyQty) stickyQty.value = val;
        }
      }

      /* leer más */
      var readMore = e.target.closest('[data-pdp-read-more]');
      if (readMore) {
        var desc = section.querySelector('[data-pdp-desc]');
        if (desc) {
          var expanded = desc.classList.toggle('is-expanded');
          readMore.textContent = expanded
            ? readMore.getAttribute('data-less')
            : readMore.getAttribute('data-more');
        }
      }

      /* play de vídeo UGC */
      var play = e.target.closest('[data-pdp-ugc-play]');
      if (play) {
        var card = play.closest('[data-pdp-ugc-card]');
        var video = card ? card.querySelector('video') : null;
        if (video) {
          if (video.paused) {
            section.querySelectorAll('[data-pdp-ugc-card] video').forEach(function (v) {
              if (v !== video) { v.pause(); v.closest('[data-pdp-ugc-card]').classList.remove('is-playing'); }
            });
            video.play();
            card.classList.add('is-playing');
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        }
      }

      /* añadir desde la barra sticky */
      var stickyAtc = e.target.closest('[data-pdp-sticky-atc]');
      if (stickyAtc) {
        var q = stickyQty ? parseInt(stickyQty.value, 10) || 1 : 1;
        addToCart(stickyAtc, q);
      }
    });

    /* ── ocultar "leer más" si la descripción no llega a recortarse ── */
    var desc = section.querySelector('[data-pdp-desc]');
    var readMoreBtn = section.querySelector('[data-pdp-read-more]');
    if (desc && readMoreBtn) {
      window.requestAnimationFrame(function () {
        if (desc.scrollHeight <= desc.clientHeight + 4) readMoreBtn.hidden = true;
      });
    }

    /* ── selling plan activo ──
       Prioriza el input propio, pero cae a cualquier [name="selling_plan"]
       asociado al form. El submit nativo está interceptado y el body se arma a
       mano, así que un input inyectado por una app de suscripciones (Skio monta
       el suyo con el atributo form="<id>", puede vivir FUERA del <form>) se
       perdería en silencio y la línea entraría como compra única. */
    function activeSellingPlan() {
      if (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) {
        return sellingPlanInput.value;
      }
      if (!form) return '';
      var sel = '[name="selling_plan"]';
      var candidates = [].slice.call(form.querySelectorAll(sel));
      if (form.id) {
        candidates = candidates.concat(
          [].slice.call(document.querySelectorAll(sel + '[form="' + form.id + '"]'))
        );
      }
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el === sellingPlanInput || el.disabled || !el.value) continue;
        if (el.type === 'radio' && !el.checked) continue;
        return el.value;
      }
      return '';
    }

    /* ── line item properties del form ──
       El body del add se arma a mano (ver activeSellingPlan), así que los
       inputs properties[...] del form hay que recogerlos aquí o se pierden en
       silencio. Crítico: properties[_gudslip_qty_tier] es la marca que activa
       la Shopify Function de tramos — sin ella el "compra 2 -10% / 3 -20%"
       se muestra en la PDP pero el checkout cobra precio completo. */
    function lineProperties() {
      if (!form) return null;
      var sel = '[name^="properties["]';
      var candidates = [].slice.call(form.querySelectorAll(sel));
      if (form.id) {
        candidates = candidates.concat(
          [].slice.call(document.querySelectorAll(sel + '[form="' + form.id + '"]'))
        );
      }
      var props = null;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.disabled || el.value === '') continue;
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (!m) continue;
        props = props || {};
        props[m[1]] = el.value;
      }
      return props;
    }

    /* ── add to cart AJAX ── */
    function addToCart(btn, quantity) {
      var id = currentVariantId();
      if (!id || btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;

      var body = { items: [{ id: id, quantity: quantity || 1 }] };
      var plan = activeSellingPlan();
      if (plan) body.items[0].selling_plan = plan;
      var props = lineProperties();
      if (props) body.items[0].properties = props;

      btn.classList.add('is-loading');
      fetch(CART_ADD_URL + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          btn.classList.remove('is-loading');
          if (!res.ok) return;
          btn.classList.add('is-added');
          window.setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () { btn.classList.remove('is-loading'); });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-pdp-atc]');
        var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (btn) addToCart(btn, q);
      });
    }

    /* ── el rating lleva al bloque de reseñas ──
       Scroll suave respetando scroll-margin-top (el header es sticky). Si la
       plantilla no monta la sección de reseñas, el enlace se queda inerte en
       vez de mandar al usuario al principio de la página. */
    var reviewsTarget = document.getElementById('gudslip-reviews');
    section.querySelectorAll('[data-pdp-reviews-link]').forEach(function (link) {
      if (!reviewsTarget) {
        link.classList.add('is-static');
        link.removeAttribute('href');
        return;
      }
      link.addEventListener('click', function (e) {
        e.preventDefault();
        /* OJO: scrollIntoView() NO funciona en este tema — base.scss pone
           overflow-x: clip en <html> y eso deja inerte tanto scrollIntoView
           como los saltos de ancla nativos. window.scrollTo sí mueve el
           viewport. El offset se lee del scroll-margin-top de la sección para
           no duplicar el valor del header sticky en dos sitios. */
        var offset = parseFloat(getComputedStyle(reviewsTarget).scrollMarginTop) || 0;
        var y = reviewsTarget.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
          top: Math.max(0, y),
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      });
    });

    /* ── count-up del % de upsell (estilo Apple: cuenta 0→N al entrar en
       viewport, con ease-out). Respeta prefers-reduced-motion. ── */
    (function () {
      var el = section.querySelector('[data-pdp-countup]');
      if (!el) return;
      var target = parseInt(el.getAttribute('data-pdp-countup'), 10);
      if (!target || isNaN(target)) return;
      if (reducedMotion) { el.textContent = String(target); return; }
      var launched = false;
      function run() {
        if (launched) return;
        launched = true;
        var dur = 1200, start = null;
        el.textContent = '0';
        function tick(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
          el.textContent = String(Math.round(eased * target));
          if (p < 1) window.requestAnimationFrame(tick);
          else el.textContent = String(target);
        }
        window.requestAnimationFrame(tick);
      }
      if ('IntersectionObserver' in window) {
        var cio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { run(); cio.disconnect(); }
          });
        }, { threshold: 0.6 });
        cio.observe(el);
      } else {
        run();
      }
    })();

    /* ── barra sticky (IntersectionObserver sobre el buy box) ── */
    var buybox = section.querySelector('[data-pdp-buybox]');
    // La barra sale SIEMPRE que el botón original no esté en pantalla — también
    // arriba del todo, mientras se miran las fotos y el buy box aún queda por
    // debajo (antes solo aparecía al dejarlo ATRÁS: `boundingClientRect.top < 0`).
    // Excepción: con el footer a la vista se esconde, para no taparlo.
    // Se calcula con rects en cada scroll (throttle por rAF) en vez de con
    // IntersectionObserver: el observer solo avisa al CRUZAR el borde, y aquí
    // hacen falta dos condiciones combinadas (buy box fuera + footer dentro)
    // que también cambian al redimensionar o al crecer la página.
    if (stickyBar && buybox) {
      var footer = document.querySelector('.gudslip-footer');
      var stickyTicking = false;

      function refreshSticky() {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var bb = buybox.getBoundingClientRect();
        var buyboxVisible = bb.bottom > 0 && bb.top < vh;
        var footerVisible = false;
        if (footer) {
          var fr = footer.getBoundingClientRect();
          footerVisible = fr.top < vh && fr.bottom > 0;
        }
        var show = !buyboxVisible && !footerVisible;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      // Throttle por tiempo (no rAF): en pestañas en segundo plano rAF se
      // suspende y la barra se quedaría con el estado de hace media hora.
      function onStickyScroll() {
        if (stickyTicking) return;
        stickyTicking = true;
        window.setTimeout(function () {
          stickyTicking = false;
          refreshSticky();
        }, 60);
      }

      window.addEventListener('scroll', onStickyScroll, { passive: true });
      window.addEventListener('resize', onStickyScroll);
      refreshSticky();
    }

    /* ── carrusel UGC: dots ── */
    var track = section.querySelector('[data-pdp-ugc-track]');
    var dotsWrap = section.querySelector('[data-pdp-ugc-dots]');
    /* QA 2026-08-14 (P3): los puntos eran UNO POR VÍDEO y el índice se calculaba
       dividiendo scrollLeft entre el ancho de tarjeta. Dos fallos: (a) salían
       aunque los vídeos cupieran todos sin scroll, y (b) al llegar al final el
       scroll se detiene en scrollWidth-clientWidth, que con varias tarjetas
       visibles da un índice N-visibles → el punto se quedaba en el antepenúltimo
       y los últimos nunca se activaban. Ahora los puntos son PÁGINAS (tantas como
       pantallas de scroll haya): si no hay scroll no se pinta ninguno, y la
       última página se activa siempre al llegar al final. Se recalcula al
       redimensionar porque clientWidth cambia con el viewport. */
    if (track && dotsWrap) {
      var ugcPages = function () {
        var cw = Math.max(1, track.clientWidth);
        return Math.max(1, Math.ceil((track.scrollWidth - 1) / cw));
      };
      var ugcHasScroll = function () {
        return track.scrollWidth > track.clientWidth + 1;
      };
      var updateDots = function () {
        var dots = dotsWrap.querySelectorAll('.gudslip-pdp__ugc-dot');
        if (!dots.length) return;
        var cw = Math.max(1, track.clientWidth);
        var idx = Math.round(track.scrollLeft / cw);
        // Al final del recorrido, siempre el ÚLTIMO punto.
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) idx = dots.length - 1;
        idx = Math.max(0, Math.min(idx, dots.length - 1));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      };
      var buildDots = function () {
        dotsWrap.innerHTML = '';
        if (!ugcHasScroll()) { dotsWrap.hidden = true; return; }
        dotsWrap.hidden = false;
        var total = ugcPages();
        for (var i = 0; i < total; i++) {
          (function (page) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'gudslip-pdp__ugc-dot' + (page === 0 ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Ir a la página ' + (page + 1) + ' de ' + total);
            dot.addEventListener('click', function () {
              track.scrollTo({ left: page * track.clientWidth, behavior: 'smooth' });
            });
            dotsWrap.appendChild(dot);
          })(i);
        }
        updateDots();
      };
      buildDots();
      var scrollTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateDots, 80);
      }, { passive: true });
      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(buildDots, 150);
      });
    }

    // #19: pill por UTM. Los query params no son legibles en Liquid → el pill se
    // renderiza oculto y se revela aquí si la URL trae el parámetro (y el valor).
    var utmPill = section.querySelector('[data-pdp-utm-pill]');
    if (utmPill) {
      try {
        var uqs = new URLSearchParams(window.location.search);
        var uparam = utmPill.getAttribute('data-utm-param') || 'utm_source';
        var uwant = utmPill.getAttribute('data-utm-value') || '';
        if (uqs.has(uparam) && (!uwant || uqs.get(uparam) === uwant)) utmPill.hidden = false;
      } catch (e) {}
    }

    refreshMode();
    if (tiersEl) setTier(1, 0);
    refresh();
  }

  /* ─────────────────────────── Reseñas (ver más) ─────────────────────── */

  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-reviews-more]');
    if (!more) return;
    var root = more.closest('[data-reviews]');
    if (!root) return;
    root.querySelectorAll('[data-review-hidden]').forEach(function (card) {
      card.removeAttribute('hidden');
      card.removeAttribute('data-review-hidden');
      card.classList.remove('is-collapsed');
    });
    more.closest('.gudslip-reviews__more-wrap').hidden = true;
  });

  /* ─────────────────────────────── boot ──────────────────────────────── */

  function boot(root) {
    (root || document).querySelectorAll('[data-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
